
import {Component, Prop, Vue} from "vue-property-decorator";
import {changeUserAccount} from "@/api/users";
import {ElForm} from "element-ui/types/form";

@Component({
  name: "ReceiptTypeForm",
})
export default class extends Vue {

  @Prop(Array) readonly options: [];


  private showEditReceiptType = false;

  private form = {
    receiptType: ''
  };
  private rules = {
    receiptType: [
      {required: true, message: "请选择单据类型", trigger: "blur"}
    ]
  }
  private selectedUserIds = [];


  public handleEditReceiptType(row) {
    this.selectedUserIds = [row.id]
    this.showEditReceiptType = true;
  }

  public cancelEditReceiptType() {
    (this.$refs['form'] as ElForm).resetFields();
    this.showEditReceiptType = false;
  }

  public confirmEditReceiptType() {
    (this.$refs['form'] as ElForm).validate(valid => {
      if (!valid) {
        return false
      }

      const obj = {
        receiptType: this.form.receiptType,
        userIds: this.selectedUserIds
      };
      changeUserAccount(obj)
          .then(() => {
            this.$message.success("操作成功");
            this.$emit("confirm")
          })
          .finally(() => {
            this.showEditReceiptType = false;
            (this.$refs['form'] as ElForm).resetFields();
          })
    })
  }
}
